function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "_clipPath_gvda2IAch4ldSryHb6gv7lShiGtI8OeT"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#_clipPath_gvda2IAch4ldSryHb6gv7lShiGtI8OeT)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: " M 17.587 13.182 C 17.612 15.639 15.639 17.612 13.182 17.588 L 7.56 17.532 C 6.619 17.523 5.863 18.279 5.872 19.22 C 5.881 20.162 6.652 20.932 7.593 20.942 L 13.511 21 C 17.688 21.041 21.041 17.688 21 13.511 L 20.942 7.594 C 20.932 6.652 20.162 5.882 19.22 5.872 C 18.279 5.863 17.523 6.619 17.532 7.56 L 17.587 13.182 Z ",
  fill: "rgb(48, 107, 246)"
}), /*#__PURE__*/React.createElement("path", {
  d: " M 3 9.113 C 3 8.21 3.732 7.479 4.635 7.479 L 7.479 7.479 L 7.479 4.634 C 7.479 3.732 8.211 3 9.114 3 C 10.017 3 10.748 3.732 10.748 4.634 L 10.748 7.478 L 13.59 7.478 C 14.493 7.478 15.225 8.21 15.225 9.112 C 15.225 10.015 14.493 10.746 13.59 10.746 L 10.746 10.746 L 10.746 13.591 C 10.746 14.493 10.014 15.225 9.111 15.225 C 8.209 15.225 7.477 14.493 7.477 13.591 L 7.477 10.747 L 4.635 10.747 C 3.732 10.747 3 10.015 3 9.113 Z ",
  fill: "rgb(48, 107, 246)"
})));

function SvgAddons(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 24 24",
    width: "24pt",
    height: "24pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddons);
export default __webpack_public_path__ + "static/media/addons.b3cbdd5d.svg";
export { ForwardRef as ReactComponent };